const state = {
  events: [],
  timeInCourse: 0,
  currentTime: 0,
  status: '',
  endOfVideo: false,
  tip: null,
};

const getters = {
  events: state => state.events,
  timeInCourse: state => state.timeInCourse,
  currentTime: state => state.currentTime,
  status: state => state.status,
  endOfVideo: state => state.endOfVideo,
  tip: state => state.tip,
};

const mutations = {
  setItem(state, { key, value }) {
    if (state[key] !== undefined) {
      state[key] = value;
    }
  },
  addEvent(state, event) {
    state.events.push(event);
  },
  clearEvents(state) {
    state.events = [];
  },
};

const actions = {
  update({ commit }, args) {
    Object.keys(args).forEach(key => {
      commit('setItem', { key, value: args[key] });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
